import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=a5fac468&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=a5fac468&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fac468",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5fac468')) {
      api.createRecord('a5fac468', component.options)
    } else {
      api.reload('a5fac468', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=a5fac468&scoped=true", function () {
      api.rerender('a5fac468', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/budget/Main.vue"
export default component.exports